import { c as _c } from "react/compiler-runtime";
import { hasWindow } from '@/utils/dom';
import Script from 'next/script';
const mockedAnalyticsLayer: {
  [key: string]: unknown;
  event: string;
}[] = [];
function usePushMockedAnalyticsLayer() {
  if (!hasWindow()) {
    return;
  }
  return () => {
    const {
      dataLayer
    } = window;
    if (!dataLayer) {
      window.dataLayer = mockedAnalyticsLayer;
    }
  };
}
export default function Analytics() {
  const $ = _c(2);
  const pushMockedAnalyticsLayer = usePushMockedAnalyticsLayer();
  if (process.env.NODE_ENV !== "production") {
    pushMockedAnalyticsLayer?.();
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <noscript><iframe title="Google Tag Manager" src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_CONTAINER_TAG}&gtm_auth=${process.env.NEXT_PUBLIC_GTM_CONTAINER_AUTH}&gtm_preview=${process.env.NEXT_PUBLIC_GTM_CONTAINER_PREVIEW}&gtm_cookies_win=x`} height="0" width="0" style={{
        display: "none",
        visibility: "hidden"
      }} /></noscript>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Script id="gtm-script" strategy="lazyOnload" dangerouslySetInnerHTML={{
        __html: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=${process.env.NEXT_PUBLIC_GTM_CONTAINER_AUTH}&gtm_preview=${process.env.NEXT_PUBLIC_GTM_CONTAINER_PREVIEW}&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', "${process.env.NEXT_PUBLIC_GTM_CONTAINER_TAG}");
  `
      }} /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}